<template>
  <div class="home-container">
    <el-container style="display: block">
      <MyHeader></MyHeader>
      <el-main>
			<!-- <span class="free">（付费小圈可生成优惠券）</span> -->
        <div class="main-title">我创建的小圈</div>
        <div class="main-box">
          <el-card class="box-card" @click.native="clickCard(item)" v-for="item in cardList" :key="item.id" :class="item.isVip == true ? 'masks' : ''">
            <img class="box-img" :src="'https://quanmai.qianniucaixin.com'+item.groupimg" />
            <div class="box-name">{{ item.groupname }}</div>
            <!-- <div class="box-time">创建{{ item.time }}天</div> -->
          </el-card>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
const _0x22f027=_0x1556;function _0x173b(){const _0x26d768=['getItem','564021gNokzr','40LmPUZs','$router','parse','/over/singleless','getData','3295ipxyAG','stringify','dxcIM','4314cPZyHv','push','33LejsUq','68600BNvhay','user','30608laegiP','28QFOKIR','HomeView','895026MFwQtA','186724mveDeX','mid','https://quanmai.qianniucaixin.com/groupxiaoquan/app_findmygroup_manage.php?mid=','data','cardList','15655596EUyqic','setItem','then'];_0x173b=function(){return _0x26d768;};return _0x173b();}(function(_0x1c7984,_0x4012ac){const _0x1db10d=_0x1556,_0x458729=_0x1c7984();while(!![]){try{const _0x4f2f07=parseInt(_0x1db10d(0x1e3))/0x1+-parseInt(_0x1db10d(0x1e8))/0x2+parseInt(_0x1db10d(0x1e2))/0x3*(-parseInt(_0x1db10d(0x1e9))/0x4)+-parseInt(_0x1db10d(0x1dd))/0x5*(parseInt(_0x1db10d(0x1e0))/0x6)+parseInt(_0x1db10d(0x1e6))/0x7*(-parseInt(_0x1db10d(0x1e5))/0x8)+-parseInt(_0x1db10d(0x1f2))/0x9*(-parseInt(_0x1db10d(0x1d8))/0xa)+parseInt(_0x1db10d(0x1ee))/0xb;if(_0x4f2f07===_0x4012ac)break;else _0x458729['push'](_0x458729['shift']());}catch(_0xe8fa43){_0x458729['push'](_0x458729['shift']());}}}(_0x173b,0x4761f));import _0x238072 from'./home/navigation/Header.vue';function _0x1556(_0x4c8e15,_0x523105){_0x4c8e15=_0x4c8e15-0x1d8;const _0x173be6=_0x173b();let _0x1556a5=_0x173be6[_0x4c8e15];return _0x1556a5;}export default{'name':_0x22f027(0x1e7),'components':{'MyHeader':_0x238072},'data'(){return{'cardList':[]};},'mounted'(){const _0x12b56c=_0x22f027;this[_0x12b56c(0x1dc)]();},'methods':{'clickCard'(_0x11268b){const _0x58ab5e=_0x22f027,_0x31eb68={'dxcIM':_0x58ab5e(0x1db)};localStorage[_0x58ab5e(0x1ef)]('groupitem',JSON[_0x58ab5e(0x1de)](_0x11268b)),this[_0x58ab5e(0x1d9)][_0x58ab5e(0x1e1)](_0x31eb68[_0x58ab5e(0x1df)]);},'getData'(){const _0x44dd01=_0x22f027,_0x38a44e=JSON[_0x44dd01(0x1da)](localStorage[_0x44dd01(0x1f1)](_0x44dd01(0x1e4)));let _0x33fe83=_0x44dd01(0x1eb)+_0x38a44e[_0x44dd01(0x1ea)];this['axios']['get'](_0x33fe83)[_0x44dd01(0x1f0)](_0x4317dc=>{const _0x15f853=_0x44dd01;this[_0x15f853(0x1ed)]=_0x4317dc[_0x15f853(0x1ec)];});}}};
</script>

<style lang="scss" scoped>
.home-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  .el-main {
    color: #333;
    padding: 70px 100px 0 100px;
    .main-title {
      margin: 0 20px;
      font-size: 18px;
		font-weight: bold;
      .free {
        color: rgb(245, 127, 89);
      }
    }
    .main-box {
      display: flex;
      flex-wrap: wrap;
      .box-card {
        margin: 20px;
        padding: 20px 36px;
        text-align: center;
        .box-img {
          width: 120px;
			 height: 120px;
          border-radius: 20px;
        }
        .box-name {
          padding: 20px 0;
          font-size: 18px;
          font-weight: bold;
        }
        .box-time {
          color: #999;
          font-size: 14px;
        }
        &.masks {
          background: url(../assets/VIP.png) no-repeat;
          background-size: 20% auto;
          background-position: 100% 0%;
        }
      }
    }
  }
}
</style>
